window.$ = window.jQuery = require('jquery');
window.Popper = require('popper.js');
require('bootstrap');
import "owl.carousel/dist/assets/owl.theme.default.css";
import "owl.carousel/dist/assets/owl.carousel.css";
import {ContactForm} from "./ContactForm";

require("owl.carousel");
require("@fancyapps/fancybox");
import "@fancyapps/fancybox/dist/jquery.fancybox.css";

const burger = document.getElementById('burger');
const burgerDesktop = document.getElementById('burger-desktop');
const menu = document.getElementById('menu');
const menuDesktop = document.getElementById('menu-desktop');
const body = document.body;
const langMenus = document.querySelectorAll('.lang-group > li > a');
const searchFormLabels = document.querySelectorAll('.open-search-form');
let langMenuOpen = false;
let searchFieldOpen = false;


document.querySelectorAll('header .menu-item-has-children > a')?.forEach((item) => {
    item.addEventListener('click', (event) => {
        event.preventDefault();
        const i = event.currentTarget.querySelector('.fas');
        i?.classList.toggle('fa-sort-down');
        i?.classList.toggle('fa-sort-up');
        event.currentTarget.parentElement.querySelector('header .sub-menu')?.classList.toggle('sub-menu--open');
    });
});


const arrowToScroll = document.querySelector('.rounded-arrow');

burger.addEventListener('click', (event) => {
    event.currentTarget.querySelector('.span')?.classList.toggle('open');
    event.currentTarget.parentElement.parentElement.querySelector('.header__menu')
    menu.classList.toggle('open');
    body.classList.toggle('menu-active');
});

burgerDesktop.addEventListener('click', (event) => {
    event.currentTarget.querySelector('.span').classList.toggle('open');
    menuDesktop.classList.toggle('open');
    body.classList.toggle('menu-active');
});

document.addEventListener('click', (even) => {
    if (langMenuOpen) {
        document.querySelector('.lang-sub-menu--open')?.classList.remove('lang-sub-menu--open');
        langMenuOpen = !langMenuOpen;
    }
    if (searchFieldOpen && !even.target.classList.contains('search-field')) {
        document.querySelector('.search-field--open')?.classList.remove('search-field--open');
        searchFieldOpen = !searchFieldOpen;
    }
});


langMenus.forEach((menu) => {
    menu.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        event.currentTarget.parentElement.querySelector('.sub-menu')?.classList.toggle('lang-sub-menu--open');
        langMenuOpen = !langMenuOpen;
    })
});

searchFormLabels.forEach((label) => {
    label.addEventListener('click', (event) => {
        event.stopPropagation();
        event.preventDefault();
        event.currentTarget.classList.toggle('open-search-form--open');
        const searchField = event.currentTarget.parentElement.querySelector('.search-field');
        searchField.classList.toggle('search-field--open');
        if (searchFieldOpen) {
            searchField.blur();
        } else {
            searchField.focus();
        }
        searchFieldOpen = !searchFieldOpen;
    })
})

if (arrowToScroll) {
    arrowToScroll.addEventListener('click', () => {
        document.getElementById('presentation').scrollIntoView({behavior: "smooth"})
    });
}


$('#owl-carousel').owlCarousel({
    loop: true,
    dots: true,
    nav: false,
    items: 1,
    margin: 10,
    responsive: {
        767: {
            items: 2,
            autoWidth: false,
            margin: 16,
            stagePadding: 0,
        },
        991: {
            items: 3,
            autoWidth: false,
            margin: 16,
            stagePadding: 0,
        },
        1649: {
            items: 4,
            autoWidth: false,
            margin: 16,
            stagePadding: 0,
        }
    }
});

$('#references-carousel').owlCarousel({
    loop: true,
    margin: 50,
    dots: true,
    nav: false,
    items: 1,
    responsive: {
        767: {
            items: 3,
        },
        991: {
            items: 4,
        },
        1199: {
            items: 5,
        }
    }
});

$('#timeline').owlCarousel({
    margin: 15,
    loop: false,
    center: true,
    items: 1,
    width: 250,
    responsive: {
        767: {
            items: 1,
        },
        991: {
            items: 2,
        },
        1199: {
            width: 250,
            items: 5
        }
    }
});

const scrollToTopBtn = document.querySelector('.upButton');
const rootElement = document.documentElement;
function scrollToTop() {
    // Scroll to top logic
    rootElement.scrollTo({
        top: 0,
        behavior: "smooth"
    })
};

scrollToTopBtn.addEventListener('click', scrollToTop);

ContactForm.init();
